import {
  array,
  bool,
  func,
  number,
  object,
  oneOfType,
  string,
} from 'prop-types'
import { useContext } from 'react'
import { WeekViewGlobalContext } from '../../../../weekViewGlobalContext'
import ContentList from './ContentList'
import ContentPlaceholderList from './ContentPlaceholderList'

const ExpandedContent = ({
  activeFilters,
  selectedFilters,
  contextMenuCallbacks,
  isMomentDragActive,
  isSelected,
  moment,
  onDragRestrictedContent,
  story,
}) => {
  // Outside Week View nothing says when content has finished loading, so a
  // card there keeps waiting for everything its moment lists.
  const { isLoadingContent = true } = useContext(WeekViewGlobalContext) ?? {}

  const isMissingContent =
    // if there are no posts but we have a post count
    (!moment.posts.length && moment.postCount) ||
    // if moment.posts includes some but not all content
    moment.postCount > moment.posts.length
  // if we have empty content objects left over after removing content from store (should be removed after addressing bug derived from store deletion issue)
  const hasEmptyContent = moment.posts.length && !moment.posts[0].name

  // A moment can list content that never arrives, such as content the person
  // cannot see, so placeholders for it last only as long as the loading does.
  if (hasEmptyContent || (isMissingContent && isLoadingContent)) {
    return <ContentPlaceholderList moment={moment} />
  }

  if (moment.posts && moment.posts.length) {
    return (
      <ContentList
        activeFilters={activeFilters}
        selectedFilters={selectedFilters}
        contextMenuCallbacks={contextMenuCallbacks}
        isMomentDragActive={isMomentDragActive}
        isSelected={isSelected}
        moment={moment}
        onDragRestrictedContent={onDragRestrictedContent}
        story={story}
      />
    )
  }

  return null
}

ExpandedContent.propTypes = {
  activeFilters: array,
  selectedFilters: object,
  contextMenuCallbacks: object,
  isMomentDragActive: bool,
  isSelected: bool,
  moment: object,
  onDragRestrictedContent: func,
  pivotName: oneOfType([number, string]),
  story: object,
}

export default ExpandedContent
